import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { reportService } from "../../../apis/apiServices/Report";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { Template } from "devextreme-react";
import { IconWithTooltip } from "../../../helper/fixcode";
import { useNavigate } from "react-router-dom";

export default function ReportAssetMovementComponent() {
  const navigate = useNavigate();
  const [assetMovementList, setAssetMovementList] = useState([]);
  const refDataGrid = useRef(null);

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = `Asset Movement`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setTimeout(async () => {
        await getAssetMovementList(0);
      }, 0);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getAssetMovementList = async (assetMovementId) => {
    try {
      refDataGrid?.current?.instance?.beginCustomLoading();
      const response = await reportService.getAssetMovementList(
        assetMovementId
      );
      setAssetMovementList(response?.data ?? []);
    } catch (error) {
      console.log(error);
    } finally {
      refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-12">
                <DataGrid
                  ref={refDataGrid}
                  dataSource={assetMovementList}
                  showColumnLines={false}
                  showRowLines={true}
                  showBorders={true}
                  allowColumnResizing={false}
                  allowColumnReordering={true}
                  columnAutoWidth={true}
                  onToolbarPreparing={(e) => {
                    e.toolbarOptions.items.unshift({
                      location: "before",
                      template: "toolbarRefreshTemplate",
                    });
                  }}
                >
                  <Column
                    dataField="id"
                    width={25}
                    caption={""}
                    allowExporting={false}
                    allowSearch={false}
                    allowFiltering={false}
                    allowSorting={false}
                    cellRender={(data) => {
                      const rowData = data?.data;
                      const idPrefix = `icon-${rowData?.id}`;
                      return (
                        <>
                          <div style={{ display: "flex" }}>
                            <span>
                              <IconWithTooltip
                                id={`${idPrefix}-view`}
                                className="iconify-size mr-1"
                                title="View"
                                tooltip="View"
                                icon="solar:document-text-outline"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  navigate("/asset-movement-preview", {
                                    state: {
                                      requestMovementId: rowData?.id,
                                      movementIndentNo:
                                        rowData?.movementIndentNo,
                                      sourceUrl: "ReportAssetMovement",
                                      isReport: true,
                                    },
                                  })
                                }
                              />
                            </span>
                          </div>
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="movementIndentNo"
                    caption="Movement ID"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Column
                    dataField="assetName"
                    caption="Asset Name"
                    allowFiltering={false}
                    allowSearch={true}
                    calculateCellValue={(data) => {
                      return `${data?.assetName || ""} ${data?.assetNo || ""}`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.assetName ?? ""}</span>
                          {data?.data?.assetNo && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.assetNo ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="categoryName"
                    caption="Category"
                    allowSearch={true}
                    calculateCellValue={(data) => {
                      return `${data?.categoryName || ""} ${
                        data?.subCategoryName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.categoryName ?? ""}</span>
                          {data?.data?.subCategoryName && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.subCategoryName ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="assetRegistrationNo"
                    caption="Serial/Registration No"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Column
                    dataField="fromProjectName"
                    caption="Project"
                    allowSearch={true}
                    calculateCellValue={(data) => {
                      return `${data?.fromProjectName || ""} ${
                        data?.toProjectName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.fromProjectName ?? ""}</span>
                          {data?.data?.toProjectName && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.toProjectName ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="fromLocation"
                    caption="Transfer From/To"
                    allowSearch={true}
                    calculateCellValue={(data) => {
                      return `${data?.fromLocation || ""} ${
                        data?.toLocation || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.fromLocation ?? ""}</span>
                          {data?.data?.toLocation && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.toLocation ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="transferType"
                    caption="Transfer Type"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Column
                    dataField="transferDate"
                    caption="Transfer Date"
                    allowFiltering={false}
                    allowSearch={true}
                    dataType="date"
                    format="dd-MMM-yyyy"
                  />

                  <Column
                    dataField="movementStatus"
                    caption="Status"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Column
                    dataField="approvedDate"
                    caption="Approved By"
                    allowSearch={true}
                    allowFiltering={false}
                    calculateCellValue={(data) => {
                      return `${data?.approvedDate || ""} ${
                        data?.approvedByUserFullName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      if (data?.data?.approvedDate) {
                        return (
                          <>
                            <span>
                              {moment(data?.data?.approvedDate).format(
                                "DD/MM/YYYY"
                              ) +
                                " " +
                                moment(data?.data?.approvedDate).format("LT") ??
                                ""}
                            </span>
                            <br />
                            <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                              {data?.data?.approvedByUserFullName ?? ""}
                            </div>
                          </>
                        );
                      } else {
                        return "";
                      }
                    }}
                  />
                  <Column
                    dataField="remark"
                    caption="Reason/ Remark"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Template
                    name="toolbarRefreshTemplate"
                    render={() => {
                      return (
                        <>
                          <button
                            className="btn btn-outline-primary btn-sm"
                            onClick={async () => {
                              await getAssetMovementList(0);
                            }}
                            title="Refresh"
                          >
                            <FontAwesomeIcon icon={faRefresh} />
                            &nbsp;Refresh
                          </button>
                        </>
                      );
                    }}
                  />
                  <HeaderFilter visible={false} />
                  <SearchPanel
                    visible={true}
                    highlightCaseSensitive={true}
                    width={240}
                    placeholder="Search..."
                  />
                  <Paging defaultPageSize={15} />
                  <Pager displayMode="compact" showInfo={true} visible={true} />
                  <Export enabled={true} fileName="Asset" />
                </DataGrid>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
